import { render, staticRenderFns } from "./FormRol.vue?vue&type=template&id=f89bb8dc&scoped=true&"
import script from "./FormRol.vue?vue&type=script&lang=js&"
export * from "./FormRol.vue?vue&type=script&lang=js&"
import style0 from "./FormRol.vue?vue&type=style&index=0&id=f89bb8dc&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f89bb8dc",
  null
  
)

export default component.exports